import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { usePagedTransactions } from "../../PaginationUtilities";
import TransactionRowDashboard from "./TransactionRowDashboard";
import { Loading } from "app/lib/components/Loading";
import { CApolloError } from "app/common/CApolloError";
const RecentActivityList = ({ account, }) => {
    const [detailTransaction, setDetailTransaction] = useState();
    const { transactions, loading, error } = usePagedTransactions(account);
    if (transactions !== undefined) {
        if (loading) {
            return _jsx(Loading, {});
        }
    }
    else {
        _jsx("div", { className: "no-data-container", children: _jsx("p", { children: "There are no transactions to display." }) });
    }
    if (error) {
        return _jsx(CApolloError, {});
    }
    return (_jsx(_Fragment, { children: _jsxs("section", { className: "transactions-list", children: [_jsxs("div", { className: "list-header", children: [_jsx("h2", { children: "Recent Activity" }), _jsxs("span", { className: "list-subhead", children: ["For Account: ", account?.Number] })] }), transactions !== undefined && transactions.length > 0 ? (_jsx("div", { className: "accord-container", children: transactions?.map((trans) => (_jsx(TransactionRowDashboard, { trans: trans, detailView: detailTransaction, setDetailView: setDetailTransaction, isCashAccount: account?.IsCashAccount }, trans?.Id))) })) : (_jsx("div", { className: "no-data-container", children: _jsx("p", { children: "There are no transactions to display." }) }))] }) }));
};
export default RecentActivityList;
